import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=080badbb"
import script from "./Catalogue.vue?vue&type=script&lang=js"
export * from "./Catalogue.vue?vue&type=script&lang=js"
import style0 from "./Catalogue.vue?vue&type=style&index=0&id=080badbb&prod&lang=css"
import style1 from "./Catalogue.vue?vue&type=style&index=1&id=080badbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports